<template>
	<template v-for="(field, name, index) in factsItemData.config.fields" :key="index">
		<div v-if="field !== '' && field !== 'Nein' &&  field !== 'keine Angabe' && field !=='-'" class="table-row col-12"
			:class="[isMultiblock == 'false' ? 'col-md-6' : '']">
			<div class="row">
				<div class="col-6 table-column">
					<span>{{ name }} </span>
				</div>
				<div class="col-6 table-column">
					<div class="icon_checkmark" v-if="field == 'Ja'">
						<span><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" xml:space="preserve" data-v-0193ec1d=""><path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8" data-v-0193ec1d=""></path></svg></span>
					</div>
					<span v-else v-html="field"></span>
				</div>
			</div>
		</div>

	</template>
</template>


<script>
export default {
	props: {
		factsItemData: {
			type: Object
		},

		isMultiblock: {
			type: String
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/factsItemComponent.scss";
</style>
